import React from 'react';

const StoreQR: React.FC = () => {
  return (
    <div className="container text-center py-4">
      <h2 className="mb-4">Download FamilienPlus</h2>
      <div className="d-flex justify-content-center gap-3 flex-wrap">
        <a
          href="https://play.google.com/store/apps/details?id=com.familienplus.familienplus"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
            alt="Bei Google Play herunterladen"
            style={{ height: '50px' }}
          />
        </a>
        <a
          href="https://apps.apple.com/de/app/familienplus/id6743626536"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
            alt="Im Appstore herunterladen"
            style={{ height: '50px' }}
          />
        </a>
      </div>
    </div>
  );
};

export default StoreQR;
